import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ApprovalContentService } from '../../services/approval-content.service';
import { ApprovalManagementService } from 'src/app/services/dataLayer/CAM/approval-management.service';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-menu-nav-listing',
    templateUrl: './menu-nav-listing.component.html',
    styleUrls: ['./menu-nav-listing.component.scss'],
    imports: [RouterLink, MatIcon]
})
export class MenuNavListingComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  content:any;
  workflowId: string = '';
  constructor(private router:Router, private contentService:ApprovalContentService, private _ApprovalManagementService:ApprovalManagementService){

  }
  ngOnInit(){
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.content = res;
    })
    this.captureWorkflowId();
  }

  captureWorkflowId() {

    const url = this.router.url;

    // match workflow-setting/30732
    const match = url.match(/workflow-setting\/(\d+)/);

    if (match && match[1]) {

      this.workflowId = match[1];
    }
  }

  isActive(route: string): boolean {
    return this.router.url.includes(route);
  }

  callByGtm(){
    this._ApprovalManagementService.approvalWorkflowSetting_menu_click('Workflow Setting');
  }

  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
  }

}
